import { useMemo } from 'react';
export var useSortedAnswerOptions = function(options) {
    return useMemo(function() {
        return options.sort(function(a, b) {
            return Number(a.option_type) - Number(b.option_type);
        });
    }, [
        options
    ]);
};
